import type { InferenceResponse } from "./getDefectsSuggestions.type";
import type { EmptyObject } from "@/types";

import { client } from "@/config/client";

export const getMaterialEndpoint = (material = "") => {
  if (!material) {
    return undefined;
  }
  return `prod-${material}-defect`;
};

export const callInferenceEndpoint = async ({ body = {}, endpoint = "" }) => {
  const data = {
    endpoint_name: endpoint,
    body: body,
  };

  let inferenceResponse = null;

  inferenceResponse = await client.inference.create(data);

  // Retry on gateway timeout due to AWS Sagemaker cold start
  const inferenceResults: InferenceResponse | EmptyObject =
    inferenceResponse !== null ? inferenceResponse.data : {};

  return inferenceResults;
};
